import React, { Component } from 'react';
import '../../App.css';
import '../../styles/app-demo.css';

class AppFooter extends Component {
  
  render() {

    return (
      <div id="app-footer-container">
      <div className="mobile-app-footer"></div>
      <div className="app-footer-transparent">
        <div onClick={() => this.props.toggleNewRoute('dashboard')} className="app-footer-item">
          <p>Home</p>
          {
            this.props.footerUnderline === 'home' ?
            <div className="orange-underline"></div>
            :
            <div></div>
          }
        </div>
        <div onClick={() => this.props.toggleNewRoute('bill pay')} className="app-footer-item">
            <p>BILL PAY</p>
            {
              this.props.footerUnderline === 'bill pay' ?
              <div className="orange-underline"></div>
              :
              <div></div>
            }
        </div>
        <div onClick={() => this.props.toggleNewRoute('menu')} className="app-footer-item">
          <p>MENU</p>
          {
            this.props.footerUnderline === 'menu' ?
            <div className="orange-underline"></div>
            :
            <div></div>
          }
        </div>
      </div>
      </div>
    )
  }
}

export default AppFooter;